import { Children, ReactNode, cloneElement, isValidElement } from 'react';

// TODO This isn't working the way it should, and needs some investigation. It is still triggering
// an error in the console, complaining that items in a list require keys set.
export const ensureKeys = (
	node: ReactNode,
	parentKey: string = 'root',
	usedKeys: Set<string> = new Set()
): ReactNode => {
	if (!isValidElement(node)) {
		return node;
	}

	// Generate or use existing key
	let elementKey = node.key ? String(node.key) : parentKey;

	// Ensure key uniqueness
	if (usedKeys.has(elementKey)) {
		let counter = 1;
		while (usedKeys.has(`${elementKey}-${counter}`)) {
			counter++;
		}
		elementKey = `${elementKey}-${counter}`;
	}
	usedKeys.add(elementKey);

	const children = node.props.children;
	if (!children) {
		return cloneElement(node, { key: elementKey });
	}

	const childrenArray = Children.toArray(children);
	const processedChildren = childrenArray.map((child, index) => {
		if (isValidElement(child)) {
			return ensureKeys(child, `${elementKey}-${index}`, usedKeys);
		}
		return child;
	});

	return cloneElement(node, { key: elementKey }, ...processedChildren);
};
